var map = {
	"./automatizacion-programas-fidelizacion.md": [
		93530,
		530
	],
	"./plataforma-omnicanal-de-fidelizacion.md": [
		6711,
		711
	],
	"./programa-de-fidelizacion-digital-para-comercios.md": [
		84745,
		745
	],
	"./sistema-fidelizacion-integracion-pos-crm.md": [
		11301,
		301
	],
	"./software-de-fidelizacion-para-pymes.md": [
		51098,
		98
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 54856;
module.exports = webpackAsyncContext;